<template>
    <defaultSec :title="'< 返回'" :returnState="true" class="ai-conversation-detail">
        <el-card size="small" class="box-card" style="margin-bottom: 20px;">
            <div slot="header">
                <span>基本信息</span>
            </div>
            <el-descriptions v-if="form.baseInfo" size="small" :column="2" border>
                <el-descriptions-item label="会话ID">
                    {{form.baseInfo.conversationId}}
                </el-descriptions-item>
                <el-descriptions-item label="耗时">
                    {{form.baseInfo.deviceInfo}}
                </el-descriptions-item>
                <el-descriptions-item label="开始时间">
                    {{form.baseInfo.startTime}}
                </el-descriptions-item>
                <el-descriptions-item label="结束时间">
                    {{form.baseInfo.endTime}}
                </el-descriptions-item>
                <el-descriptions-item label="设备信息">
                    {{form.baseInfo.deviceInfo}}
                </el-descriptions-item>
            </el-descriptions>
        </el-card>
        <el-card size="small" class="box-card" style="margin-bottom: 20px;">
            <div slot="header">
                <span>得分评价</span>
                <el-popover
                    placement="left-start"
                    title="得分评价"
                    width="300"
                    trigger="hover">
                    <div style="margin: 20px 0;padding-left: 20px;font-size: 12px">
                        <div style="display: flex;margin: 10px 0 20px;">
                            是否金牌话术：
                            <el-switch
                                size="mini"
                                v-model="isGoldenResponse">
                            </el-switch>
                        </div>
                        <div style="display: flex;margin: 10px 0;" v-for="item in compositeScore">
                            {{item.title}}:
                            <el-rate
                                style="margin-left: 10px;"
                                v-model="item.value"
                                show-score
                                text-color="#ff9900"
                                score-template="{value}">
                            </el-rate>
                        </div>
                        <div style="display: flex;justify-content: flex-end">
                            <el-button type="danger" size="mini" @click="saveEvaluation">保存</el-button>
                        </div>

                    </div>
                    <el-button slot="reference" style="float: right;" size="mini" round plain type="primary">评分</el-button>

                </el-popover>
            </div>
            <el-descriptions v-if="form.evaluation" size="small" :column="1" border>
                <el-descriptions-item label="金牌话术">
                    <i v-if="form.evaluation.goldenResponse" style="font-size: 30px;color:green" class="el-icon-medal-1"></i>
                </el-descriptions-item>
                <el-descriptions-item label="综合得分">
                    <div style="display: flex;margin: 10px 0;" v-for="item in setScoreList(form.evaluation.compositeScore||{})">
                        {{item.title}}:
                        <el-rate
                            style="margin-left: 10px;"
                            v-model="item.value"
                            disabled
                            show-score
                            allow-half
                            text-color="#ff9900"
                            score-template="{value}">
                        </el-rate>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="评分记录">
                    <el-timeline>
                        <el-timeline-item color="blue" v-for="item in form.evaluation.records" :timestamp="item.evaluationTime" placement="top">
                            <el-card shadow="hover">
                                <h4>{{item.details.notes}}( {{ item.evaluatorType }} )</h4>
                                <div style="font-size: 12px">
                                    <div style="display: flex;margin: 10px 0;" v-for="itemM in setScoreList(item.details||{})">
                                        {{itemM.title}}:
                                        <el-rate
                                            style="margin-left: 10px;"
                                            v-model="itemM.value"
                                            disabled
                                            show-score
                                            allow-half
                                            text-color="#ff9900"
                                            score-template="{value}">
                                        </el-rate>
                                    </div>
                                </div>
                            </el-card>
                        </el-timeline-item>
                    </el-timeline>
                </el-descriptions-item>
            </el-descriptions>
        </el-card>
        <el-card size="small" class="box-card" style="margin-bottom: 20px;">
            <div slot="header">
                <span>会话记录</span>
            </div>
            <el-timeline v-if="form.messages&&form.messages.length>0">
                <el-timeline-item color="green" v-for="item in form.messages" :timestamp="item.timestamp" placement="top">
                    <el-card shadow="hover">
                        <div style="display: flex;justify-content: flex-end">
                            <el-button size="mini" round plain type="danger" @click="()=>openDialog(item.messageId)">优化反馈</el-button>

                        </div>

                        <h4>{{item.content}}</h4>
                        <div style="font-size: 12px" v-if="item.optimizationSuggestionVoList.length>0">
                            <i style="margin-right: 5px;color: red" class="el-icon-location"></i>优化反馈：
                            <el-timeline style="margin: 20px 0;font-size: 12px">
                                <el-timeline-item
                                    placement="top"
                                    v-for="(itemM, indexM) in item.optimizationSuggestionVoList"
                                    :key="indexM"
                                    :timestamp="itemM.suggestionTime+'（'+itemM.suggestedBy+'）'">
                                    <div>{{itemM.suggestedResponse}}</div>
                                    <div>{{itemM.suggestedImprovement}}</div>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                        <div style="font-size: 12px" v-if="item.userFeedbackVoList.length>0">
                            <i style="margin-right: 5px;color: #00a1ff" class="el-icon-location"></i>用户反馈：
                            <el-timeline style="margin: 20px 0;font-size: 12px">
                                <el-timeline-item
                                    placement="top"
                                    v-for="(itemM, indexM) in item.userFeedbackVoList"
                                    :key="indexM"
                                    :timestamp="itemM.feedbackTime">
                                    <el-tag size="mini">{{itemM.isHelpful?'有用':'无用'}}</el-tag> {{itemM.feedbackText}}
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </el-card>
                </el-timeline-item>
            </el-timeline>
        </el-card>
        <el-dialog
            title="优化反馈"
            :visible.sync="dialogVisible"
            width="60%">
            <el-form ref="form" :model="messageForm" label-width="40px">
                <el-form-item label="标题">
                    <el-input v-model="messageForm.suggestedResponse"></el-input>
                </el-form-item>
                <el-form-item label="内容">
                    <el-input type="textarea" v-model="messageForm.suggestedImprovement"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-radio-group v-model="messageForm.status">
                        <el-radio label="待定">待定</el-radio>
                        <el-radio label="已执行">已执行</el-radio>
                        <el-radio label="拒绝">拒绝</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="danger" @click="saveMessage">提交</el-button>
              </span>
        </el-dialog>
    </defaultSec>
</template>

<script>
    import defaultSec from '@c/defaultSection'
    import tablePagination from '@c/tablePagination'
    export default {
        data() {
            return {

                form: {
                    id: this.$route.params.id || 0,
                },
                compositeScore:[],
                titleName: {
                    accuracy:'准确性评分',
                    relevance:'相关性评分',
                    fluency:'流畅性评分',
                    safety:'安全性评分',
                    coherence:'连贯性评分'
                },
                scoreForm: {
                    accuracy:0,
                    relevance:0,
                    fluency:0,
                    safety:0,
                    coherence:0,
                }, isGoldenResponse:false,
                messageForm:{

                },
                dialogVisible:false
            }
        },
        components: {
            defaultSec, tablePagination
        },
        mounted(){
            if(this.form.id){
                this.compositeScore = this.setScoreList(this.scoreForm)
                this.getDetail()
            }
        },
        methods: {
            getDetail() {
                this.$apiGet('lechun-ai/conversation/getDetail', { conversationId: this.$route.params.id}).then(res => {
                    this.form = res
                })
            },
            saveEvaluation() {
                let scoreObj = {}
                this.compositeScore.map(item=>{
                    scoreObj[item.key+'Score'] = item.value
                })
                this.$apiPost('lechun-ai/conversation/setGoldSession', {
                    conversationId: this.$route.params.id,
                    isGoldenResponse: this.isGoldenResponse,
                    ...scoreObj
                }).then(res => {
                    this.$message({
                        showClose: true,
                        message: '成功',
                        type: 'success'
                    });
                    this.getDetail()
                    this.compositeScore = []
                    this.isGoldenResponse = false
                })
            },
            openDialog(messageId) {
                this.messageForm.messageId = messageId
                this.dialogVisible = true
            },
            saveMessage(messageId) {
                this.$apiPost('lechun-ai/message/saveSuggestion', {
                    ...this.messageForm
                }).then(res => {
                    this.$message({
                        showClose: true,
                        message: '成功',
                        type: 'success'
                    });
                    this.getDetail()
                    this.messageForm = {}
                    this.dialogVisible = false
                })
            },
            setScoreList(obj={}){
                let compositeScoreKey = Object.keys(obj).sort()
                let result = []
                compositeScoreKey.map((item)=>{
                    if(this.titleName.hasOwnProperty(item)){
                        result.push({
                            key:item,
                            title:this.titleName[item],
                            value:obj[item]
                        })
                    }

                })
                return result
            }
        }
    }
</script>


<style lang="scss">
    .ai-conversation-detail{
        .el-card__body{
            padding: 10px;
        }
        .el-card__header{
            padding: 10px 20px;
        }
        h4{
            margin: 15px 0;
        }
    }
</style>